module.exports = __webpack_public_path__ + "static/img/2gaofen1.04d60732.png";